export enum IconType {
    Common = 'common',
    Service = 'service',
}

export enum InputType {
    Date = 'date',
    Hidden = 'hidden',
    Select = 'select',
    Checkbox = 'checkbox',
    Daterange = 'daterange',
}

export enum InputSize {
    Unset = '',
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
}

// @deprecated: Use specific variants instead
export enum InputVariant {
    Default = 'default',
    Primary = 'primary',
    Danger = 'danger',
    Warning = 'warning',
    Success = 'success',
    Dark = 'dark',
    Info = 'info',
}

export enum ButtonVariant {
    Default = 'default',
    Dark = 'dark',
    Danger = 'danger',
    Success = 'success',
    Primary = 'primary',
    Warning = 'warning',
    Tenancy = 'tenancy',
}

export enum ButtonType {
    Button = 'button',
    Submit = 'submit',
    Link = 'link',
    Router = 'router',
    File = 'file',
}

export enum DialogVariant {
    Primary = 'primary',
    Success = 'success',
    Warning = 'warning',
    Danger = 'danger',
}

export enum SwitchVariant {
    Primary = 'primary',
    Info = 'info',
    Success = 'success',
    Warning = 'warning',
    Danger = 'danger',
}

export enum TagVariant {
    Info = 'info',
    Primary = 'primary',
    Success = 'success',
    Warning = 'warning',
    Danger = 'danger',
    Dark = 'dark',
    Custom = 'custom',
}

export enum TagSize {
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
}

export enum SliderSize {
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
}

export enum DialogType {
    Confirm = 'confirm',
    Prompt = 'prompt',
    Alert = 'alert',
}

export enum NotificationVariant {
    Info = 'info',
    Success = 'success',
    Warning = 'warning',
    Danger = 'danger',
    Custom = 'custom',
}

export enum ContentAlignment {
    Baseline = 'baseline',
    Center = 'center',
}

export enum SortOrder {
    Ascending = 'asc',
    Descending = 'desc',
}

export enum ElementPosition {
    TopRight = 'top-right',
    Top = 'top',
    TopLeft = 'top-left',
    BottomRight = 'bottom-right',
    Bottom = 'bottom',
    BottomLeft = 'bottom-left',
}
